<template>

    <v-card
      class="ids-corpora-filter px-2"
    >
      <ids-corpus-category
        v-for="(corpusItems, name) in corpusByCategory"
          :key="name"
          :corpusCategoryName="name"
          :corpusItems="corpusItems"
          :selection="dataCorpusSelection[name]"
          @ids-corpus-selection-change="onCorpusSelectionChange"
      />

    </v-card>

</template>

<script>

import CorpusCategory from './IdsCorpusCategory.vue';

export default {
  name: 'ids-corpora-filter',
  components: {
    'ids-corpus-category': CorpusCategory
  },
  props: {
    corpusListApi: { type: Array, required: true },
    corpusSelection: { type: Object, required: true }
  },
  data () {
    return {
      dataCorpusSelection: this.corpusSelection
    }
  },
  computed: {
    /** Get the corpora aggregated by their categories */
    corpusByCategory () {
      const aggregate = {};
      this.corpusListApi.forEach(korp => {
        if (!aggregate[korp.v_corpus_cat]) {
          aggregate[korp.v_corpus_cat] = [];
        }
        aggregate[korp.v_corpus_cat].push(korp);
      });

      return aggregate;
    }
  },

  methods: {
    /**
     * Handles change of corpus checkboxes.
     * Updates the state (corpusSelection) mapping category to selection array.
     */
    onCorpusSelectionChange (corpusCategory, newCorpusSelection) {
      this.dataCorpusSelection[corpusCategory] = newCorpusSelection;

      this.$emit('ids-corpus-selection-change', this.dataCorpusSelection);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// app/ids/components/filter/IdsCorporaFilter.vue